module.exports = __webpack_public_path__ + "4bb31940edbe161f9a6b05e75bd904f1.MP3";